<template>
  <div>
    <app-view-layout header="Nowy wniosek DKO współpraca">
      <template #content>
        <v-form
          ref="form"
          v-model="isFormValid"
          @submit.prevent="submit"
        >
          <DkoFormCard
            v-model="form"
            class="mt-4 mb-8"
          />

          <ProjectFilesCard
            ref="filesCard"
            title="Załączniki"
            :files="files"
            hide-tabs
            disable-download
            :processing="isProcessing"
            class="mb-8"
            @add="showFileAddDialog"
            @delete="deleteFiles"
          />

          <v-btn
            class="mb-8"
            color="primary"
            type="submit"
            height="40"
            :loading="isProcessing"
          >
            Wyślij wniosek
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import DkoFormCard from '@/components/DkoCooperation/DkoFormCard.vue';
import ProjectFilesCard from '@/components/Projects/ProjectFilesCard.vue';

export default {
  components: {
    AppViewLayout,
    DkoFormCard,
    ProjectFilesCard,
  },
  data() {
    return {
      isFormValid: false,
      form: {
        name: '',
        departmentId: null,
        purpose: null,
        customPurpose: '',
        deadline: '',
        description: '',
        usageAssessment: false,
        kiwNumberAssignment: false,
        externalEntityApproval: false,
        printCoordination: false,
      },
    };
  },
  computed: {
    ...mapState('dkoCooperation', ['isProcessing']),
    ...mapState('files', ['files']),
    ...mapState('filters', ['filtersOptions']),
  },
  created() {
    if (!this.filtersOptions.departments?.length) this.fetchFiltersOptions();
  },
  beforeDestroy() {
    this.clearTempFiles();
  },
  methods: {
    ...mapActions('dkoCooperation', ['createRequest']),
    ...mapActions('files', ['deleteTempFiles', 'clearTempFiles']),
    ...mapActions('filters', ['fetchFiltersOptions']),
    ...mapActions('dialog', ['showDialog']),
    ...mapActions('snackbar', ['showSnackbar']),
    submit() {
      if (this.isProcessing) return;
      const valid = this.$refs.form.validate();
      if (!valid) {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
        return;
      }

      const payload = {
        ...this.form,
        files: this.files.map((file) => file.data),
      };
      if (!payload.customPurpose) delete payload.customPurpose;
      this.createRequest(payload);
    },
    showFileAddDialog() {
      this.showDialog({
        header: 'Dodawanie pliku',
        text: 'Wybierz plik i dodaj do wniosku.',
        component: 'FileAdd',
      });
    },
    deleteFiles(fileIds) {
      this.deleteTempFiles(fileIds);
      this.$refs.filesCard.clearSelection();
    },
  },
};
</script>
